import React from "react";
import PropTypes from 'prop-types';
import MaterialIcon from "shared/react_components/MaterialIcon";

const WarningToggle = ({ open, toggle, count }) => {
  const ref = React.createRef();
  const iconName = open ? "expand_more" : "chevron_right";

  return (
    <span data-label="dropdown-toggle" onClick={toggle}>
      <MaterialIcon ref={ref} name={iconName} style={{ fontSize: "13px", paddingRight: "5px" }} />&nbsp;
      Show Numbers ({count})
    </span>
  );
};

WarningToggle.propTypes = {
  open:   PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  count:  PropTypes.number.isRequired
};

export default WarningToggle;
